(() => {
  const doc = document.documentElement;
  const body = document.body;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isHome = window.location.pathname === '/' || window.location.pathname === '';

  doc.classList.add('nv-motion-ready');

  if (isHome) {
    body.classList.add('nv-home');

    const heroSection = document.querySelector('#MainContent > .shopify-section:first-child');

    if (heroSection && !document.querySelector('.nv-brand-rail')) {
      const rail = document.createElement('div');
      rail.className = 'nv-brand-rail';
      rail.setAttribute('aria-label', 'New Visions Markenwerte');

      const phrase = 'ORIGINAL ARTWORK  /  MADE TO ORDER  /  GRAPHIC STREETWEAR  /  AACHEN, GERMANY  /  ';
      rail.innerHTML = `
        <div class="nv-brand-rail__track">
          <p class="nv-brand-rail__item">${phrase}${phrase}</p>
          <p class="nv-brand-rail__item" aria-hidden="true">${phrase}${phrase}</p>
        </div>
      `;

      heroSection.insertAdjacentElement('afterend', rail);
    }

    requestAnimationFrame(() => body.classList.add('nv-hero-visible'));
  }

  const progress = document.createElement('div');
  progress.className = 'nv-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  body.appendChild(progress);

  let scrollTicking = false;

  const updateScrollState = () => {
    const y = window.scrollY || 0;
    const scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
    progress.style.transform = `scaleX(${Math.min(1, y / scrollable)})`;
    body.classList.toggle('nv-header-scrolled', y > 24);
    scrollTicking = false;
  };

  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      requestAnimationFrame(updateScrollState);
      scrollTicking = true;
    }
  }, { passive: true });

  updateScrollState();

  const sections = [...document.querySelectorAll('#MainContent > .shopify-section')]
    .filter((section, index) => !(isHome && index === 0));

  sections.forEach((section) => section.classList.add('nv-reveal'));

  if (reducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries, currentObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      currentObserver.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.08,
  });

  sections.forEach((section) => observer.observe(section));
})();

